//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum DeliveryMethodAvailability {
	Ok = 0,
	AddressNotSelected = 1,
	DeliveryMethodNotSelected = 2,
	InvalidDimensions = 3,
	MailboxNotEligible = 4,
	PorterBuddyNotAvailable = 5,
	PorterBuddyAddressNotSupported = 6,
	PorterBuddyWindowNotSelected = 7,
	PostNordServicePointNotAvailable = 8,
	PostNordServicePointNotSelected = 9,
	InstaBoxExpressNotAvailable = 10,
	InstaBoxHomeNotAvailable = 11,
	NotAvailable = 12,
	HeltHjemNotAvailable = 13,
	PostNHomeNotAvailable = 14,
	PostNPickNotAvailable = 15,
	PostNPickLockersNotAvailable = 16,
	BadTemperatures = 17,
	AirmeeHomeNotAvailable = 18,
	OtcNotAvailable = 19,
	RxNotAvailable = 20,
	HeltHjemServicePointNotAvailable = 21,
	GordonNotAvailable = 22
}
